module.exports = __webpack_public_path__ + "img/logo-itkib.819cda43.svg";